import axios from 'axios';
import { XMLParser } from 'fast-xml-parser';

export async function parseRSSFeed(feedUrl: string): Promise<{ feed: any }> {
  const { data } = await axios.get(feedUrl);
  const parser = new XMLParser({ ignoreAttributes: false, attributeNamePrefix: '' });
  const xml = parser.parse(data);
  return { feed: { ...xml.rss.channel, items: xml.rss.channel.item, item: undefined } };
}
